// extracted by mini-css-extract-plugin
export default {"img":"LandingImage_img__I1aMT","container":"LandingImage_container__vUwmQ","letsGoButton":"LandingImage_letsGoButton__VtsHx"};